import { useQuery } from "@apollo/client";

import {
  ARTICLE_INDEX,
  ARTICLE_SERIES_ARTICLES_INDEX,
} from "@/components/pieces/algolia/indexes";
import ArticleSeriesSearch from "@/components/pieces/learn/search/ArticleSeriesSearch";
import { hasValidToken } from "@/components/session/JwtTokenManager";
import { ArticleSeries, ArticleSeriesReadStatusDocument } from "@/graphql";

interface ArticleSeriesContainerProps {
  articleSeries: ArticleSeries;
}

export default function ArticleSeriesContainer({
  articleSeries,
}: ArticleSeriesContainerProps) {
  const { data } = useQuery(ArticleSeriesReadStatusDocument, {
    variables: {
      slug: articleSeries.urlSlug,
    },
    fetchPolicy:
      import.meta.env.SSR || hasValidToken() ? "cache-and-network" : undefined,
  });

  const articleSeriesReadStatus = data ? data.articleSeriesReadStatus : {};

  const {
    totalItemCount,
    readInprogressArticleIds: inprogressIds = [],
    readCompletedArticleIds: completetedIds = [],
  } = articleSeriesReadStatus;
  const arsById = {};
  completetedIds.forEach((articleId) => {
    const strId = `${articleId}`; // for Algolia
    arsById[strId] = "READING_COMPLETED";
  });
  inprogressIds.forEach((articleId) => {
    const strId = `${articleId}`; // for Algolia
    arsById[strId] = "READING_IN_PROGRESS";
  });
  const completedItemCount = completetedIds.length;
  const inprogressItemCount = inprogressIds.length;
  const readStatus = {
    totalItemCount,
    completedItemCount,
    inprogressItemCount,
    articleReadStatusById: arsById,
  };
  const indexName =
    articleSeries && articleSeries.urlSlug === "other-articles"
      ? ARTICLE_INDEX
      : ARTICLE_SERIES_ARTICLES_INDEX;
  return (
    <ArticleSeriesSearch
      indexName={indexName}
      articleSeries={articleSeries}
      readStatus={readStatus}
    />
  );
}
